<div class="productDetailsPictures">
  <div *ngIf="pictures.length; else noPic">
    <div class="productDetailsPictures__gallery --desktop">
      <figure class="productDetailsPictures__figure" *ngFor="let picture of pictures, let i = index" (click)="openGallery(i)"  [ngClass]="{'--bigger': pictures.length <= 2}">
        <img [ngSrc]="picture" width="100%" height="" [alt]="title">
        <button *ngIf="i === 0 && virtualMirror" (click)="runVirtualMirror($event)" class="productDetailsPictures__buttonVirtualMirror flaticon-frame a-button-try-life --try-life-pdp">
          {{'productDetails.pictures.virtualMirrorButton' | translate}}
        </button>
        <ng-container *ngIf="i === 0 && priceInformations.discountDescription">
          <i *ngIf="!priceInformations.discountCmsPageLabel; else promobutton" class="productDetailsPictures__promotion">{{priceInformations.discountDescription}}</i>
          <ng-template #promobutton><button class="productDetailsPictures__promotion" (click)="openURL($event, priceInformations.discountDescription)">{{priceInformations.discountDescription}}</button></ng-template>
        </ng-container>
      </figure>
    </div>
    <div #sliderRef class="productDetailsPictures__gallery keen-slider --mobile">
      <div class="keen-slider__slide" *ngFor="let picture of pictures, let i = index" >
        <img [ngSrc]="picture" width="100%" height="" [alt]="title" (click)="openGallery(i)">
      </div>
      <button *ngIf="virtualMirror" (click)="runVirtualMirror($event)" class="productDetailsPictures__buttonVirtualMirror flaticon-frame a-button-try-life --try-life-pdp">
        {{'productDetails.pictures.virtualMirrorButton' | translate}}
      </button>
      <ng-container *ngIf="priceInformations.discountDescription">
        <i *ngIf="!priceInformations.discountCmsPageLabel; else promobutton" class="productDetailsPictures__promotion">{{priceInformations.discountDescription}}</i>
        <ng-template #promobutton><button class="productDetailsPictures__promotion" (click)="openURL($event, priceInformations.discountDescription)">{{priceInformations.discountDescription}}</button></ng-template>
      </ng-container>
      <button *ngIf="slider" class="lg-prev lg-icon" [ngClass]="{'--disabled': currentSlide === 0}" (click)="slider.prev()"></button>
      <button *ngIf="slider" class="lg-next lg-icon" [ngClass]="{'--disabled': currentSlide === slider.track.details.slides.length - 1}" (click)="slider.next()"></button>
    </div>
    <ul class="productDetailsPictures__thumbs">
      <li *ngFor="let picture of pictures, let i = index" [ngClass]="{'--selected': i === currentSlide}">
        <button (click)="slideTo(i)"><img [src]="picture" [alt]="title"></button>
      </li>
    </ul>
    <v-product-gallery [pictures]="pictures" [title]="title" [currentSlide]="gallery" *ngIf="gallery > -1" (close)="closeGallery()"></v-product-gallery>
  </div>
  <ng-template #noPic>
    <figure><img ngSrc="{{noPicSrc}}" width="700" height="200" [alt]="'productDetails.images.nopic' | translate" /></figure>
  </ng-template>
</div>
